import {createPreview} from '/preview_functions/preview.js';
import { createElement } from "/elements_functions/new_elements.js";
import { createBranchPreview, createTreeConnectionsForAll } from '/explore_field_functions/content_preview.js';
import { mouseDownDragExplore, mouseMoveDragExplore, mouseUpDragExplore } from '/explore_field_functions/cursor_explore_functions.js';
import { getExploreCoordinates, moveExploreToCoordinates, moveExploreFieldTo,
    centerExploreFieldAroundTheBranch, goToBranch, goToBranchWithDistanceToScreen,
    getClosestBranchToScreen, getBranchDistanceToScreen,
    scaleExploreField, scaleExploreFieldBy } from "/explore_field_functions/movement_functions.js";
import { createZoomController } from "/explore_field_functions/controls.js";
import { truncateNameAndDescription } from '/explore_field_functions/content_preview.js';

let globalMouseMoveEventsAdded = false;

const buildFunctionsDictionaryPrototype = {
    onRevealMore : null
}

export function createExploreMini(branchInfo, addBuildFunctionsDictionary=null) {
    const exploreMiniFieldWrapper = createElement('div', null, ['explore-mini-field-wrapper']);
    const exploreMiniField = createElement('div', null, ['explore-mini-field', 'explore-general-field']);

    console.log("addBuildFunctionsDictionary ", addBuildFunctionsDictionary);
    
    const buildFunctionsDictionary = {};

    const sharedRevealParams = {};

    buildFunctionsDictionary.beforeRevealMore = (parentId) => beforeRevealMore(sharedRevealParams, exploreMiniField, parentId);

    buildFunctionsDictionary.onRevealMore = (parentId, newBranches, newBranchesDictionary) => onRevealMore(sharedRevealParams, exploreMiniField,
        parentId, newBranchesDictionary);

    if(addBuildFunctionsDictionary!==null) {
        if(addBuildFunctionsDictionary.onRevealMore !== null && addBuildFunctionsDictionary.onRevealMore instanceof Function)
            buildFunctionsDictionary.onRevealMore = (parentId, newBranches, newBranchesDictionary) => {
                onRevealMore(sharedRevealParams, exploreMiniField, parentId, newBranchesDictionary);
                addBuildFunctionsDictionary.onRevealMore(exploreMiniField, newBranches);
            };
    }

    const branchAndLineage = createBranchPreview(branchInfo, null, buildFunctionsDictionary);
    exploreMiniField.exploreBranchesDictionary = branchAndLineage.exploreBranchesDictionary;
    exploreMiniField.append(branchAndLineage);

    exploreMiniFieldWrapper.append(exploreMiniField);

    const body = document.querySelector('body');

    if(globalMouseMoveEventsAdded===false) {
        body.addEventListener('mousemove', (e)=>mouseMoveDragExplore(e));
        body.addEventListener('mouseup', (e)=>mouseUpDragExplore(e));
        globalMouseMoveEventsAdded = true;
    }

    exploreMiniField.addEventListener('mousedown', (e)=>mouseDownDragExplore(e));

    exploreMiniFieldWrapper.exploreMiniField = exploreMiniField;
    exploreMiniFieldWrapper.exploreField = exploreMiniField;

    exploreMiniField.exploreMiniFieldWrapper = exploreMiniFieldWrapper;
    exploreMiniField.exploreFieldWrapper = exploreMiniFieldWrapper;

    const getExploreCoordinatesFunction = () => getExploreCoordinates(exploreMiniFieldWrapper, exploreMiniField);
    exploreMiniFieldWrapper.getExploreCoordinates = getExploreCoordinatesFunction;
    exploreMiniField.getExploreCoordinates = getExploreCoordinatesFunction;

    const moveExploreToCoordinatesFunction = (x, y) => moveExploreToCoordinates(exploreMiniFieldWrapper, exploreMiniField, x, y);
    exploreMiniFieldWrapper.moveExploreToCoordinates = moveExploreToCoordinatesFunction;
    exploreMiniField.moveExploreToCoordinates = moveExploreToCoordinatesFunction;

    const moveExploreToFunction = (leftPos, topPos) => moveExploreFieldTo(exploreMiniFieldWrapper, exploreMiniField, leftPos, topPos);
    exploreMiniFieldWrapper.moveExploreFieldTo = moveExploreToFunction;
    exploreMiniField.moveExploreFieldTo = moveExploreToFunction;

    const scaleExploreFieldFunction = (scale) => scaleExploreField(exploreMiniField, scale);
    exploreMiniFieldWrapper.scaleExploreField = scaleExploreFieldFunction;
    exploreMiniField.scaleExploreField = scaleExploreFieldFunction;

    const scaleExploreFieldByFunction = (scaleChange) => scaleExploreFieldBy(exploreMiniField, scaleChange);
    exploreMiniFieldWrapper.scaleExploreFieldBy = scaleExploreFieldByFunction;
    exploreMiniField.scaleExploreFieldBy = scaleExploreFieldByFunction;

    exploreMiniFieldWrapper.getMouseCoordinatesInField = (event) => calculateMouseOffsetToParentElement(event, exploreMiniField);
    exploreMiniField.getMouseCoordinatesInField = (event) => calculateMouseOffsetToParentElement(event, exploreMiniField);

    /*
    exploreMiniField.addEventListener('wheel', (event) => {
        event.preventDefault();

        let zoomChange = 1.1**(-event.deltaY/50);
        
        const oldScale = exploreMiniField.zoomScale;
        const newScale = zoomChange*oldScale;
        const minZoomValue = exploreMiniField.minZoomValue;
        const maxZoomValue = exploreMiniField.maxZoomValue;

        if(newScale > maxZoomValue) {
            zoomChange = maxZoomValue/oldScale;
        } else if(newScale < minZoomValue) {
            zoomChange = minZoomValue/oldScale;
        }

        const mouseCoordinates = exploreMiniField.getMouseCoordinatesInField(event);

        const oldCoordinates = exploreMiniField.getExploreCoordinates();
        

        const newX = oldCoordinates.x + (oldCoordinates.x-mouseCoordinates.x)*(1-zoomChange);
        const newY = oldCoordinates.y + (oldCoordinates.y-mouseCoordinates.y)*(1-zoomChange);

        exploreMiniField.scaleExploreFieldBy(zoomChange);
        exploreMiniField.moveExploreToCoordinates(newX, newY);
    });
*/
    exploreMiniField.addEventListener('wheel', (event) => {
        event.preventDefault();

        let zoomChange = 1.1**(-event.deltaY/50);
        
        const oldScale = exploreMiniField.zoomScale;
        const newScale = zoomChange*oldScale;
        const minZoomValue = exploreMiniField.minZoomValue;
        const maxZoomValue = exploreMiniField.maxZoomValue;

        if(newScale > maxZoomValue) {
            zoomChange = maxZoomValue/oldScale;
        } else if(newScale < minZoomValue) {
            zoomChange = minZoomValue/oldScale;
        }

        const mouseCoordinates = exploreMiniField.getMouseCoordinatesInField(event);

        const oldLeft = exploreMiniField.leftPos;
        const oldTop = exploreMiniField.topPos;
        

        const newLeft = oldLeft - (mouseCoordinates.x-exploreMiniField.offsetWidth/2)*(1-zoomChange)*oldScale;
        const newTop = oldTop - (mouseCoordinates.y-exploreMiniField.offsetHeight/2)*(1-zoomChange)*oldScale;

        exploreMiniField.scaleExploreFieldBy(zoomChange);
        exploreMiniField.moveExploreFieldTo(newLeft, newTop);
    });

    const centerExploreFieldAroundTheBranchFunction = (branchId) => centerExploreFieldAroundTheBranch(exploreMiniFieldWrapper, branchId);
    exploreMiniFieldWrapper.centerExploreFieldAroundTheBranch = centerExploreFieldAroundTheBranchFunction;
    exploreMiniField.centerExploreFieldAroundTheBranch = centerExploreFieldAroundTheBranchFunction;

    const goToBranchFunction = (branchId) => goToBranch(exploreMiniFieldWrapper, exploreMiniField, branchId);
    exploreMiniFieldWrapper.goToBranch = goToBranchFunction;
    exploreMiniField.goToBranch = goToBranchFunction;

    const goToBranchWithDistanceToScreenFunction = (branchId, distanceLeft, distanceTop) => goToBranchWithDistanceToScreen(exploreMiniFieldWrapper, exploreMiniField, branchId, distanceLeft, distanceTop);
    exploreMiniFieldWrapper.goToBranchWithDistanceToScreen = goToBranchWithDistanceToScreenFunction;
    exploreMiniField.goToBranchWithDistanceToScreen = goToBranchWithDistanceToScreenFunction;

    const getBranchDistanceToScreenFunction = (branchId) => getBranchDistanceToScreen(exploreMiniField, branchId);
    exploreMiniFieldWrapper.getBranchDistanceToScreen = getBranchDistanceToScreenFunction;
    exploreMiniField.getBranchDistanceToScreen = getBranchDistanceToScreenFunction;

    const getClosestBranchToScreenFunction = () => getClosestBranchToScreen(exploreMiniFieldWrapper, exploreMiniField);
    exploreMiniFieldWrapper.getClosestBranchToScreen = getClosestBranchToScreenFunction;
    exploreMiniField.getClosestBranchToScreen = getClosestBranchToScreenFunction;

    const createTreeConnectionsForAllFunction = () => createTreeConnectionsForAll(exploreMiniFieldWrapper);
    exploreMiniFieldWrapper.createTreeConnectionsForAll = createTreeConnectionsForAllFunction;
    exploreMiniField.createTreeConnectionsForAll = createTreeConnectionsForAllFunction;

    const truncateNameAndDescriptionFunction = () => truncateNameAndDescription(exploreMiniFieldWrapper);
    exploreMiniFieldWrapper.truncateNameAndDescription = truncateNameAndDescriptionFunction;
    exploreMiniField.truncateNameAndDescription = truncateNameAndDescriptionFunction;

    const getContentDimensionsFunction = () => getContentDimensions(branchAndLineage);
    exploreMiniFieldWrapper.getContentDimensions = getContentDimensionsFunction;
    exploreMiniField.getContentDimensions = getContentDimensionsFunction;

    const regsiterContentDimensionsFunction = () => regsiterContentDimensions(exploreMiniField);
    exploreMiniFieldWrapper.regsiterContentDimensions = regsiterContentDimensionsFunction;
    exploreMiniField.regsiterContentDimensions = regsiterContentDimensionsFunction;

    const registerZoomLimitFunction = () => registerZoomLimit(exploreMiniField);
    exploreMiniFieldWrapper.registerZoomLimit = registerZoomLimitFunction;
    exploreMiniField.registerZoomLimit = registerZoomLimitFunction;

    const setUpDimensionsFunction = () => setUpDimensions(exploreMiniFieldWrapper, exploreMiniField);
    exploreMiniFieldWrapper.setUpDimensions = setUpDimensionsFunction;
    exploreMiniField.setUpDimensions = setUpDimensionsFunction;
    
    const createZoomControllerFunction = () => createZoomController(exploreMiniFieldWrapper, exploreMiniField);
    exploreMiniFieldWrapper.createZoomController = createZoomControllerFunction;
    exploreMiniField.createZoomController = createZoomControllerFunction;

    const initiateAfterRenderFunction = () => initiateAfterRender(exploreMiniField);
    exploreMiniFieldWrapper.initiateAfterRender = initiateAfterRenderFunction;
    exploreMiniField.initiateAfterRender = initiateAfterRenderFunction;

    const replaceExploreContentWithNewInfoFunction = (familyInfo, addBuildFunctionsDictionary=null) =>
        replaceExploreContentWithNewInfo(exploreMiniField, branchAndLineage, familyInfo, addBuildFunctionsDictionary);
    exploreMiniFieldWrapper.replaceExploreContentWithNewInfo = replaceExploreContentWithNewInfoFunction;
    exploreMiniField.replaceExploreContentWithNewInfo = replaceExploreContentWithNewInfoFunction;



    return exploreMiniFieldWrapper;

}

function calculateMouseOffsetToParentElement(event, endParent) {
    const currentElement = event.target;    

    const sumOfParentOffets = calcSumOfParentOffets(currentElement, endParent);

    return {
        x: event.offsetX + sumOfParentOffets.offsetLeft,
        y: event.offsetY + sumOfParentOffets.offsetTop
    };
}

function calcSumOfParentOffets(element, endParent) {
    
    if(element===endParent) {
        return {
            offsetLeft: 0,
            offsetTop: 0
        };
    } else {
        const nextOffset = calcSumOfParentOffets(element.offsetParent, endParent);
        return {
            offsetLeft: element.offsetLeft + nextOffset.offsetLeft,
            offsetTop: element.offsetTop + nextOffset.offsetTop
        };
    }
}

function setUpDimensions(exploreFieldWrapper, exploreField) {
    const minZoomValue = exploreField.minZoomValue;
    const additionalCoefficient = 1/(1-minZoomValue);
    

    let horizontalPadding = (exploreFieldWrapper.offsetWidth-exploreField.contentWidth*minZoomValue) / minZoomValue / 2;
    let verticalPadding = (exploreFieldWrapper.offsetHeight-exploreField.contentHeight*minZoomValue) / minZoomValue / 2;
    //const verticalPadding = exploreField.contentHeight * additionalCoefficient / 2;
    
    horizontalPadding = Math.max(0, horizontalPadding);
    verticalPadding = Math.max(0, verticalPadding);
    
    exploreField.horizontalPadding = horizontalPadding;
    exploreField.verticalPadding = verticalPadding;
    
    exploreField.style.padding = `${verticalPadding}px ${horizontalPadding}px`;
}

function getContentDimensions(firstBranch) {
    const contentWidth = firstBranch.offsetWidth;
    const contentHeight = firstBranch.offsetHeight;

    return { contentWidth: contentWidth, contentHeight: contentHeight };
}

function regsiterContentDimensions(exploreField) {
    const contentDimensions = exploreField.getContentDimensions();

    exploreField.contentWidth = contentDimensions.contentWidth;
    exploreField.contentHeight = contentDimensions.contentHeight;
}

function registerZoomLimit(exploreField) {
    /*
    exploreField.zoomLimitCoefficient = 650;

    const contentWidth = exploreField.contentWidth;
    const contentHeight = exploreField.contentHeight;

    const zoomLimitCoefficient = exploreField.zoomLimitCoefficient;

    exploreField.minZoomValue = Math.min(zoomLimitCoefficient/contentWidth*1.1, zoomLimitCoefficient/contentHeight*1.1, 0.8);
    exploreField.maxZoomValue = 2;

    exploreField.zoomScale = 1;
    */

    const exploreFieldWrapper = exploreField.exploreFieldWrapper;

    const wrapperWidth = exploreFieldWrapper.offsetWidth;
    const wrapperHeight = exploreFieldWrapper.offsetHeight;

    const contentWidth = exploreField.contentWidth;
    const contentHeight = exploreField.contentHeight;

    const horizontalProportion = wrapperWidth/(contentWidth+100);
    const verticalProportion = wrapperHeight/(contentHeight+100);

    exploreField.minZoomValue = Math.min(horizontalProportion, verticalProportion, 0.8);
    exploreField.maxZoomValue = 2;
}

function initiateAfterRender(exploreField) {
    
    exploreField.truncateNameAndDescription();
    exploreField.regsiterContentDimensions();
    exploreField.registerZoomLimit();
    exploreField.setUpDimensions();
    exploreField.createZoomController();
    exploreField.createTreeConnectionsForAll();
    
    exploreField.zoomScale = 1;
}

function replaceExploreContentWithNewInfo(exploreField, content, familyInfo, addBuildFunctionsDictionary) {
    
    const closestBranchId = exploreField.getClosestBranchToScreen().branchId;
    const screenDistanceToClosestBranchId = exploreField.getBranchDistanceToScreen(closestBranchId);

    const oldLeftPos = exploreField.leftPos;
    const oldTopPos = exploreField.topPos;
    const oldZOom = exploreField.zoomScale;

    content.remove();
    content = null;

    const buildFunctionsDictionary = {};

    const sharedRevealParams = {};

    buildFunctionsDictionary.beforeRevealMore = (parentId) => beforeRevealMore(sharedRevealParams, exploreField, parentId);
    
    buildFunctionsDictionary.onRevealMore = (parentId, newBranches, newBranchesDictionary) => onRevealMore(sharedRevealParams, exploreField, parentId, newBranchesDictionary);

    if(addBuildFunctionsDictionary!==null) {
        if(addBuildFunctionsDictionary.onRevealMore !== null && addBuildFunctionsDictionary.onRevealMore instanceof Function)
            buildFunctionsDictionary.onRevealMore = (parentId, newBranches, newBranchesDictionary) => {
                onRevealMore(sharedRevealParams, exploreField, parentId, newBranchesDictionary);
                addBuildFunctionsDictionary.onRevealMore(exploreField, newBranches);
            };
    }

    const newContent = createBranchPreview(familyInfo, null, buildFunctionsDictionary);

    exploreField.append(newContent);

    exploreField.exploreBranchesDictionary = newContent.exploreBranchesDictionary;

    exploreField.getContentDimensions = () => getContentDimensions(newContent);
    exploreField.replaceExploreContentWithNewInfo = (familyInfo, addBuildFunctionsDictionary=null) =>
        replaceExploreContentWithNewInfo(exploreField, newContent, familyInfo, addBuildFunctionsDictionary);

    const observer = new ResizeObserver(entries => {
        for (const entry of entries) {
          if (entry.contentRect.width > 0 && entry.contentRect.height > 0) {
            exploreField.initiateAfterRender();
        
            exploreField.scaleExploreField(oldZOom);
            exploreField.goToBranchWithDistanceToScreen(closestBranchId, screenDistanceToClosestBranchId.distanceLeft, screenDistanceToClosestBranchId.distanceTop);
            observer.disconnect();
          }
        }
      });
      
    observer.observe(exploreField.exploreFieldWrapper);
      
}

function initiateLineageDom(lineageDom, parentId) {
    lineageDom.parentId = parentId;
}

function beforeRevealMore(sharedRevealParams, exploreField, parentId) {
    const distanceToScreen = exploreField.getBranchDistanceToScreen(parentId);

    sharedRevealParams.distanceToScreen = distanceToScreen;

}

function onRevealMore(sharedRevealParams, exploreField, parentId, newBranchesDictionary) {

    const zoomController = exploreField.zoomController;
    const zoomScale = exploreField.zoomScale;

    const exploreBranchesDictionary = exploreField.exploreBranchesDictionary;

    for(const [key, value] of Object.entries(newBranchesDictionary)) {
        exploreBranchesDictionary[key] = value;
    }

    deleteAllTreeConnections(exploreField);
    
    exploreField.truncateNameAndDescription();
    exploreField.regsiterContentDimensions();
    exploreField.registerZoomLimit();
    exploreField.setUpDimensions();
    exploreField.createTreeConnectionsForAll();

    zoomController.min = exploreField.minZoomValue;
    zoomController.max = exploreField.maxZoomValue;

    zoomController.value = zoomScale;
    
    const distanceToScreen = sharedRevealParams.distanceToScreen;
    
    
    exploreField.goToBranchWithDistanceToScreen(parentId, distanceToScreen.distanceLeft, distanceToScreen.distanceTop);
}

function deleteAllTreeConnections(exploreField) {

    const existingConnections = exploreField.querySelectorAll('.explore-window-branch-wrapper-lineage-link');

    for(let i of existingConnections) {
        i.remove();
    }
}

export function findFirstExploreField(element) {
    const explroeField = element.querySelector('explore-general-field');

    return explroeField;
}